import { render, staticRenderFns } from "./RealIntentionPreviewPc.vue?vue&type=template&id=d7ebcb12&scoped=true"
import script from "./RealIntentionPreviewPc.vue?vue&type=script&lang=js"
export * from "./RealIntentionPreviewPc.vue?vue&type=script&lang=js"
import style0 from "./RealIntentionPreviewPc.vue?vue&type=style&index=0&id=d7ebcb12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ebcb12",
  null
  
)

export default component.exports